var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["connect"]: () => __WEBPACK_EXTERNAL_MODULE_react_redux_87be03b0__.connect });